import * as React from 'react';
import { unstable_NormalPriority as NormalPriority, unstable_runWithPriority as runWithPriority } from 'scheduler';
var isSSR = typeof window === 'undefined' || /ServerSideRendering/.test(window.navigator && window.navigator.userAgent);
export var useIsomorphicLayoutEffect = isSSR ? React.useEffect : React.useLayoutEffect;
export function runWithNormalPriority(thunk) {
  return runWithPriority(NormalPriority, thunk);
}
//# sourceMappingURL=utils.js.map
